// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ProductCategories_SalvarInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /so/product_categories/salvar
 *
 * Creates or updates a product category.
 */
import { registerContract } from './validate'

export interface ProductCategories_SalvarInput {
so_product_category_name: string
so_product_category_id?: number
so_product_category_franchise_id?: number
}

registerContract('ProductCategories_SalvarInput', {
  so_product_category_name:         { type: 'string',  required: true },
  so_product_category_id:           { type: 'number',  required: false },
  so_product_category_franchise_id: { type: 'number',  required: false },
})
